import { useState, useMemo } from "react";
import "./App.css";
import "./index.css";
import HomePage from "./HomePage/HomePage";
import Register from "./LoginRegister/Register/Register";
import Footer from "./SidebarHeader/Footer/Footer";
import Header from "./SidebarHeader/Header/Header";
import Sidebar from "./SidebarHeader/Sidebar/Sidebar";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import MyProfile from "./HomePage/Profile/MyProfile";
import TimeTable from "./DCM/components/Time-table";
import { Navigate } from "react-router-dom";
import HomeWorkMain from "./HwManagement/HomeWork/HomeWorkMain";
import ActivityMain from "./HwManagement/Activity/ActivityMain";
import PreReadMain from "./HwManagement/PreRead/PreReadMain";
import SummaryMain from "./DcmDetails/Summary/SummaryMain";
import LiveMain from "./DcmDetails/Live/LiveMain";
import AssesmentMain from "./DcmDetails/Assesment/AssesmentMain";
import LibraryMain from "./HomePage/Library/LibraryMain";
import GroupWiseQuery from "./Engagement/StudentQuery/Group_Wise_Query/GroupWiseQuery";
import { useSelector } from "react-redux";
import PendingSubDetails from "./HwManagement/PreRead/Pending/PendingSubDetails";
import CompletedSubDetails from "./HwManagement/PreRead/Completed/CompletedSubDetails";
import QueryEngagement from "./Engagement/Query/QueryEngagement";
import EngagementCommunity from "./Engagement/Community/EngagementCommunity";
import GroupDetails from "./Engagement/Community/GroupDetails";
import FeedDetail from "./Engagement/Open_community/Feed_Detail/FeedDetail";
import TotalCommuPost from "./Engagement/Open_community/total_community_post/TotalCommuPost";
import ViewFirstScreen from "./Engagement/Create_channel/View_Channel_Screen/View_First_Screen/ViewFirstScreen";
import CreateCommunity from "./Engagement/Create_channel/Create/Create";
import AllQuestions1 from "./DcmDetails/Assesment/Pending/QuestionTypes/AllQuestions";
import AllQuestions2 from "./DcmDetails/Assesment/Onreview/QuestionTypes/AllQuestions";
import AllQuestions3 from "./DcmDetails/Assesment/Completed/QuestionCompleted/AllQuestions";

import LibrarySubjectDetail from "./HomePage/Library/LibraySubjectDatail/LibrarySubjectDetail";
import LibraryChapterDetails from "./HomePage/Library/LibraySubjectDatail/LibraryChapter/LibraryChapterDetails";
import { useEffect } from "react";
import RegisterSuccess from "./LoginRegister/Register/RegisterSuccess";
import LoginSuccess from "./LoginRegister/Register/LoginSuccess";
import HeaderContext from "./HeaderContext";
import UnRegSuccess from "./LoginRegister/Register/UnRegSuccess";
import AllQuestions from "./HwManagement/HomeWork/Pending/QuestionTypes/AllQuestions";
import AllQuestions4 from "./HwManagement/HomeWork/Completed/QuestionCompleted/AllQuestions";
import AllQuestions5 from "./HwManagement/HomeWork/OnReview/QuestionTypes/AllQuestions";
import ActivityPendingSubjDetail from "./HwManagement/Activity/Pending/ActivityPendingSubjDetail";
import ActivityOnReviewSubDetail from "./HwManagement/Activity/OnReview/ActivityOnReviewSubDetail";
import ActivityCompletedSubDetail from "./HwManagement/Activity/Completed/ActivityCompletedSubDetail";
import ResetSuccess from "./LoginRegister/Register/ResetSuccess";
// import SummaryUpdated from "./DcmDetails/Summary/SummaryUpdated/SummaryUpdated";
import TicketsMain from "./Ticket";
import SelfAssessment from "./DcmDetails/SelfAssessment/SelfAssessment";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TicketPopup from "./Ticket/TicketPopup";
import SummaryUpdated from "./DCM/components/SummaryUpdated/SummaryUpdated";
import AdaptiveAss from "./DcmDetails/Assesment/Pending/AdaptiveAss";
import CompletedAdaptiveQues from "./DcmDetails/Assesment/Completed/CompletedAdaptiveQues";
import StudentAttendance from "./Student_attendance/StudentAttendance";
import ViewReport from "./Student_attendance/View_report/ViewReport";
import TakeAttendance from "./Student_attendance/Take_attendance/TakeAttendance";
import StudentPerformance from "./StudentPerformance/StudentPerformance";
import NotFound from "./components/ui/NotFound";
import NotAuthorized from "./components/ui/Notauthorized";
import { fullAsessment, hasFeature } from "./utils/features";
import MyPlanner from "./DCM/components/MyPlanner";
import FeatureGuide from "./components/featureGuide";
import PreviousAssessment from "./DcmDetails/Assesment/Pending/PreviousAssessment";
import Safety from "./SafetyManagement/Safety";

let classTeachers = [];
let coOrdinators = [];

const validateLogin = (feature) => {
  let raw = localStorage.getItem("breathForStudent");

  if (!raw || raw === "undefined" || raw === "null") {
    return false;
  }

  if (feature && !hasFeature(feature)) {
    return false;
  }

  return true;
};

function App() {
  const storedSetLogin = useSelector((state) => state.user.currentUser);

  let studentDetail = JSON.parse(localStorage.getItem("breathForStudent"));
  const [countComment, setCommentCount] = useState(0);
  const [footer, setFooter] = useState({
    footerMenu: "Home",
    myProfile: false,
    ticket: false,
    setIsLoggedIn: false,
  });

  const location = useLocation();

  // 🔥 Check for full-screen pages (no sidebar/header/footer)
  const noLayoutRoutes = [
    "/",
    "/loginSuccessful",
    "/regSuccess",
    "/resetSuccessful",
    "/unRegSuccessful",
  ];
  const isFullScreenPage = noLayoutRoutes.includes(location.pathname);

  const handleProfile = () => {
    setFooter({
      ...footer,
      myProfile: true,
    });
  };
  const navigate = useNavigate();

  const handleTicket = () => {
    setFooter({
      ...footer,
      ticket: true,
    });
  };

  const handleProfileClose = () => {
    setFooter({
      ...footer,
      myProfile: false,
    });
  };

  const handleTicketClose = () => {
    setFooter({
      ...footer,
      ticket: false,
    });
  };

  useEffect(() => {
    getAllClassTeachers();
    getAllCoOrdinators();
  }, []);

  function getAllClassTeachers() {
    studentDetail?.teacher_information?.forEach((element) => {
      if (element.is_class_teacher === true) {
        const teachers = element.teacher.name;
        classTeachers.push(teachers);
      }
    });
  }
  function getAllCoOrdinators() {
    studentDetail?.teacher_information?.forEach((element) => {
      if (element.is_Co_Ordinator === true) {
        const co_ordinator = element.teacher.name;
        coOrdinators.push(co_ordinator);
      }
    });
  }

  // fro sidemenu active
  const [sidebarMenu, setSideBarMenu] = useState({
    activeMenu: "Dashboard",
    activeMenuHW: "Homework",
    activeMenuSummary: "Summary",
    activeMenuEngage: "Comunity",
    activeMenuPerformance: "Performance",
  });

  //dashboard
  const changeActiveMenuHome = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenu: newActiveMenu });
    localStorage.setItem("homeSideMenu", newActiveMenu);
  };
  //smart assignment
  const changeActiveMenuHw = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuHW: newActiveMenu });
    localStorage.setItem("hwSideMenu", newActiveMenu);
  };

  // digital class
  const changeActiveMenuSummary = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuSummary: newActiveMenu });
    localStorage.setItem("summarySideMenu", newActiveMenu);
  };

  // engagement
  const changeActiveMenuEngage = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuEngage: newActiveMenu });
    localStorage.setItem("engageSideMenu", newActiveMenu);
  };
  //performance
  const changeActiveMenuPerformance = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuPerformance: newActiveMenu });
    localStorage.setItem("performanceSideMenu", newActiveMenu);
  };

  const [studentData, setStudentData] = useState("");
  useEffect(() => {
    let studentId = JSON.parse(localStorage.getItem("breathForStudent"));
    setStudentData(studentId);
  }, []);

  useEffect(() => {
    const path = location.pathname;

    // Determine footer tab based on route
    if (path.includes("/HomePage")) {
      setFooter({ footerMenu: "Home" });
      localStorage.setItem("footerActive", "Home");
    } else if (path.includes("/Summary")) {
      setFooter({ footerMenu: "DCM" });
      localStorage.setItem("footerActive", "DCM");
    } else if (path.includes("/Homework")) {
      setFooter({ footerMenu: "HMW" });
      localStorage.setItem("footerActive", "HMW");
    } else if (path.includes("/EngagementCommunity")) {
      setFooter({ footerMenu: "Engagement" });
      localStorage.setItem("footerActive", "Engagement");
    } else if (path.includes("/student-performance")) {
      setFooter({ footerMenu: "Performance" });
      localStorage.setItem("footerActive", "Performance");
    } else {
      // fallback to last saved tab
      const saved = localStorage.getItem("footerActive");
      if (saved) setFooter({ footerMenu: saved });
    }
  }, [location.pathname]);

  const contextValue = useMemo(
    () => ({
      handleProfile,
      handleTicket,
      countComment,
      setCommentCount,
    }),
    [countComment],
  );

  return (
    <>
      <ToastContainer
        style={{ zIndex: 999999 }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <HeaderContext.Provider value={contextValue}>
        {/* 🔥 FIX: Inline styles for 100% Full Screen */}
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            margin: 0,
            padding: 0,
            backgroundColor: isFullScreenPage ? "#ffffff" : "#f8f9fd",
          }}
        >
          {/* 🔥 Sidebar - Only if NOT Full Screen */}
          {!isFullScreenPage && (
            <div style={{ flexShrink: 0, height: "100%" }}>
              <Sidebar
                footer={footer.footerMenu}
                sidebarMenuHome={sidebarMenu.activeMenu}
                changeActiveMenuHome={changeActiveMenuHome}
                changeActiveMenuHw={changeActiveMenuHw}
                sidebarMenuW={sidebarMenu.activeMenuHW}
                changeActiveMenuSummary={changeActiveMenuSummary}
                sidebarMenuSummary={sidebarMenu.activeMenuSummary}
                changeActiveMenuEngage={changeActiveMenuEngage}
                sidebarMenuEnggage={sidebarMenu.activeMenuEngage}
                changeActiveMenuPerformance={changeActiveMenuPerformance}
                sidebarMenuPerformance={sidebarMenu.activeMenuPerformance}
              />
            </div>
          )}

          {footer.ticket && (
            <TicketPopup handleTicketClose={handleTicketClose} />
          )}

          {footer.myProfile && (
            <MyProfile
              handleProfileClose={handleProfileClose}
              classTeachers={classTeachers}
              coOrdinators={coOrdinators}
            />
          )}

          {!footer.myProfile && !footer.ticket && (
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                width: isFullScreenPage ? "100%" : "auto",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {/* 🔥 Header - Only if NOT Full Screen */}
              {!isFullScreenPage && (
                <div
                  className="MainHeaderContainer mt-2"
                  style={{ flexShrink: 0, zIndex: 10 }}
                >
                  <Header
                    handleProfile={handleProfile}
                    handleTicket={handleTicket}
                    sidebarMenuW={sidebarMenu.activeMenuHW}
                  />
                </div>
              )}

              {/* 🔥 Main Content Area */}
              <div
                style={{
                  flex: 1,
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                  height: "100%",
                  padding: isFullScreenPage ? 0 : "0 12px",
                  margin: 0,
                }}
              >
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={<Register setFooter={setFooter} footer={footer} />}
                  />
                  <Route
                    exact
                    path="/HomePage"
                    element={
                      validateLogin() ? (
                        <HomePage data={studentData} />
                      ) : (
                        <Navigate to="/" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Calender"
                    element={
                      validateLogin("TTBL_MGT") ? (
                        <TimeTable />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/my-planner"
                    element={
                      validateLogin("STUDY_PLN") ? (
                        <MyPlanner />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/student-safety"
                    element={
                      validateLogin("STUDENT_SAFETY") ? (
                        <Safety />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Library"
                    element={
                      validateLogin("CONT_LIB") ? (
                        <LibraryMain />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Contents/SubjectDetails"
                    element={
                      validateLogin("CONT_LIB") ? (
                        <LibrarySubjectDetail />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Contents/ChapterDetails/:index/:isContinue"
                    element={
                      validateLogin("CONT_LIB") ? (
                        <LibraryChapterDetails />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Homework"
                    element={
                      validateLogin("AS_HW") ? (
                        <HomeWorkMain type="Homework" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />

                  <Route
                    exact
                    path="/publishedhomework"
                    element={
                      validateLogin("AS_HW") ? (
                        <AllQuestions type="HW" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/reviewHomework"
                    element={
                      validateLogin("AS_HW") ? (
                        <AllQuestions5 />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/completedHomework"
                    element={
                      validateLogin("AS_HW") ? (
                        <AllQuestions4 type="HW" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/PreRead"
                    element={
                      validateLogin("AS_PR") ? (
                        <PreReadMain type="Pre-read" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/preReads/published"
                    element={
                      validateLogin("AS_PR") ? (
                        <PendingSubDetails />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/presRead/completed"
                    element={
                      validateLogin("AS_PR") ? (
                        <CompletedSubDetails />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    path="/feedDetail"
                    element={
                      validateLogin("COMMUNITY") ? (
                        <FeedDetail />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    path="/EngagementCommunity"
                    element={
                      validateLogin("COMMUNITY") ? (
                        <TotalCommuPost />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    path="/viewFirstScreen"
                    element={
                      validateLogin("COMMUNITY") ? (
                        <ViewFirstScreen />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/CreateCommunity"
                    element={
                      validateLogin("COMMUNITY") ? (
                        <CreateCommunity />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Activity"
                    element={
                      validateLogin("AS_ACT") ? (
                        <ActivityMain type="Activity" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/publishedActivity"
                    element={
                      validateLogin("AS_ACT") ? (
                        <ActivityPendingSubjDetail />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/reviewActivity"
                    element={
                      validateLogin("AS_ACT") ? (
                        <ActivityOnReviewSubDetail />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/completedActivity"
                    element={
                      validateLogin("AS_ACT") ? (
                        <ActivityCompletedSubDetail />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/publishedActivity"
                    element={
                      validateLogin("AS_ACT") ? (
                        <ActivityMain />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Summary"
                    element={
                      validateLogin("LEC_SUM") ? (
                        <SummaryMain />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Summaryupdate"
                    element={
                      validateLogin("LEC_SUM") ? (
                        <SummaryUpdated />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Live"
                    element={
                      validateLogin("TTBL_CAl_MGT") ? (
                        <LiveMain />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Assessment"
                    element={
                      validateLogin() && fullAsessment ? (
                        <AssesmentMain />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Assessment/completed"
                    element={
                      validateLogin() && fullAsessment ? (
                        <AllQuestions3 />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Assessment/adaptivequestion"
                    element={
                      validateLogin() && fullAsessment ? (
                        <AdaptiveAss />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Assessment/adaptivequestion/completed"
                    element={
                      validateLogin() && fullAsessment ? (
                        <CompletedAdaptiveQues />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/Assessment/previousassessment"
                    element={
                      storedSetLogin ? (
                        <PreviousAssessment />
                      ) : (
                        <Navigate to="/" />
                      )
                    }
                  />
                  <Route
                    path="/Assessment/pending/questions/:assessmentId"
                    element={
                      validateLogin() && fullAsessment ? (
                        <AllQuestions1 />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/SelfAssessment"
                    element={
                      validateLogin("SELF_ASS") ? (
                        <SelfAssessment type="Self-Assessment" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/publishedSelfAssessment"
                    element={
                      validateLogin("SELF_ASS") ? (
                        <AllQuestions type="SA" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/completedSelfAssessment"
                    element={
                      validateLogin("SELF_ASS") ? (
                        <AllQuestions4 type="SA" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/retestSelfAssessment"
                    element={
                      validateLogin("SELF_ASS") ? (
                        <AllQuestions2 type="SA" />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route path="/regSuccess" element={<RegisterSuccess />} />
                  <Route path="/loginSuccessful" element={<LoginSuccess />} />
                  <Route path="/resetSuccessful" element={<ResetSuccess />} />
                  <Route path="/unRegSuccessful" element={<UnRegSuccess />} />
                  <Route
                    path="/Assessment/review/questions"
                    element={
                      validateLogin() && fullAsessment ? (
                        <AllQuestions2 />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/EngagementQuery"
                    element={
                      validateLogin("DOUBT_SOLV") ? (
                        <QueryEngagement />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    path="/groupWiseQuery"
                    element={
                      validateLogin("DOUBT_SOLV") ? (
                        <GroupWiseQuery />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/EngagementCommunity"
                    element={
                      validateLogin("COMMUNITY") ? (
                        <EngagementCommunity />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/ticketMain"
                    element={
                      validateLogin() ? <TicketsMain /> : <Navigate to="/" />
                    }
                  />
                  <Route
                    exact
                    path="/student-attendance"
                    element={
                      validateLogin("SELF_ATT") ? (
                        <StudentAttendance />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/view-report"
                    element={
                      validateLogin("SELF_ATT") ? (
                        <ViewReport />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/take-attendance"
                    element={
                      validateLogin("SELF_ATT") ? (
                        <TakeAttendance />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/403/unauthorized"
                    element={<NotAuthorized />}
                  />
                  <Route
                    exact
                    path="/student-performance"
                    element={
                      validateLogin("OL_PERF") ? (
                        <StudentPerformance />
                      ) : (
                        <Navigate to="/403/unauthorized" />
                      )
                    }
                  />
                  <Route
                    path="*"
                    element={
                      validateLogin() ? <NotFound /> : <Navigate to="/" />
                    }
                  />
                  <Route
                    exact
                    path="/feature-guide"
                    element={
                      storedSetLogin ? <FeatureGuide /> : <Navigate to="/" />
                    }
                  />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </div>

              {/* 🔥 Footer - Only if NOT Full Screen */}
              {!isFullScreenPage && (
                <div
                  className="MainFooterContainer"
                  style={{ flexShrink: 0, zIndex: 10 }}
                >
                  <Footer
                    setFooter={setFooter}
                    footer={footer.footerMenu}
                    changeActiveMenuHome={changeActiveMenuHome}
                    changeActiveMenuHw={changeActiveMenuHw}
                    changeActiveMenuSummary={changeActiveMenuSummary}
                    changeActiveMenuEngage={changeActiveMenuEngage}
                    changeActiveMenuPerformance={changeActiveMenuPerformance}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </HeaderContext.Provider>
    </>
  );
}

export default App;
